// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XWgNIBV8SL9_YW_P {
	display: flex;
	padding: var(--lok-spacing-6);
	padding-right: 0;
	padding-bottom: 0;
	background-color: var(--lok-color-background-surface-middle);
	border-radius: var(--lok-radius-xl);
	height: 100%;
}

.pWOgeIFL71QEubsE {
	display: flex;
	flex-direction: column;
	gap: var(--lok-spacing-5);
	flex: 1;
	border: 1px solid var(--lok-color-border-light);
	padding: var(--lok-spacing-7);
	border-right: 0;
	border-bottom: 0;
	border-top-left-radius: var(--lok-radius-l);
}

.xs64TPEyy4qKV6_e {
	display: grid;
	grid-template-columns: 1fr auto 2fr;
	grid-template-rows: auto 1fr auto;
	grid-gap: var(--lok-spacing-3);
}

.RG8i_eycAvlNcbYj {
	display: flex;
	align-items: center;
	grid-area: 1 / 2 / 2 / 3;
}

.FGngKWW_S50GAwjn {
	max-height: 450px;
	overflow: auto;
	grid-area: 1 / 3 / 3 / 4;
}

.qxtYX4D9FMYZzbHo {
	grid-area: 3 / 1 / 4 / 4;
}

.wwqVk4q4zXw_JjRZ {
	display: flex;
	flex-wrap: wrap;
	gap: var(--lok-spacing-1);
}

.FMqupTC5ECgCCIf4 {
	background-color: var(--lok-color-background-surface-fore);
	color: var(--lok-color-text-default);
	border: none;
}

.EtsIZU2n3W4N0hPe {
	background-color: var(--lok-color-background-warning);
	color: var(--lok-color-text-warning);
	font: var(--lok-typography-body-tiny-default);
}

.wdvRZq_FGeYPjehu {
	display: flex;
	flex-direction: column;
	gap: var(--lok-spacing-2);
}

.lrYptlxhok0jDBbz {
	font: var(--lok-typography-heading-4);

	&.pj9IKS_hMaK0lnSP {
		color: var(--lok-color-text-disabled);
	}
}

.q3mqaD2PiQFiNJuL {
	color: var(--lok-color-text-success);
	background-color: var(--lok-color-background-success);
	border: none;

	height: 100%;
	padding: var(--lok-spacing-1) var(--lok-spacing-2);
}

.oFJwfT7yGLMao9cD {
	display: flex;
	align-items: center;
	background-color: var(--lok-color-background-surface-fore);
	border-radius: var(--lok-radius-tag);
	padding: var(--lok-spacing-1) var(--lok-spacing-2);
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/KeysForLanguage/KeysForLanguage.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,6BAA6B;CAC7B,gBAAgB;CAChB,iBAAiB;CACjB,4DAA4D;CAC5D,mCAAmC;CACnC,YAAY;AACb;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,yBAAyB;CACzB,OAAO;CACP,+CAA+C;CAC/C,6BAA6B;CAC7B,eAAe;CACf,gBAAgB;CAChB,2CAA2C;AAC5C;;AAEA;CACC,aAAa;CACb,mCAAmC;CACnC,iCAAiC;CACjC,8BAA8B;AAC/B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,wBAAwB;AACzB;;AAEA;CACC,iBAAiB;CACjB,cAAc;CACd,wBAAwB;AACzB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,0DAA0D;CAC1D,oCAAoC;CACpC,YAAY;AACb;;AAEA;CACC,qDAAqD;CACrD,oCAAoC;CACpC,6CAA6C;AAC9C;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,qCAAqC;;CAErC;EACC,qCAAqC;CACtC;AACD;;AAEA;CACC,oCAAoC;CACpC,qDAAqD;CACrD,YAAY;;CAEZ,YAAY;CACZ,kDAAkD;AACnD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,0DAA0D;CAC1D,oCAAoC;CACpC,kDAAkD;AACnD","sourcesContent":[".outerContainer {\n\tdisplay: flex;\n\tpadding: var(--lok-spacing-6);\n\tpadding-right: 0;\n\tpadding-bottom: 0;\n\tbackground-color: var(--lok-color-background-surface-middle);\n\tborder-radius: var(--lok-radius-xl);\n\theight: 100%;\n}\n\n.borderWrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: var(--lok-spacing-5);\n\tflex: 1;\n\tborder: 1px solid var(--lok-color-border-light);\n\tpadding: var(--lok-spacing-7);\n\tborder-right: 0;\n\tborder-bottom: 0;\n\tborder-top-left-radius: var(--lok-radius-l);\n}\n\n.container {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr auto 2fr;\n\tgrid-template-rows: auto 1fr auto;\n\tgrid-gap: var(--lok-spacing-3);\n}\n\n.icon {\n\tdisplay: flex;\n\talign-items: center;\n\tgrid-area: 1 / 2 / 2 / 3;\n}\n\n.target {\n\tmax-height: 450px;\n\toverflow: auto;\n\tgrid-area: 1 / 3 / 3 / 4;\n}\n\n.projects {\n\tgrid-area: 3 / 1 / 4 / 4;\n}\n\n.projectsContainer {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tgap: var(--lok-spacing-1);\n}\n\n.projectsTag {\n\tbackground-color: var(--lok-color-background-surface-fore);\n\tcolor: var(--lok-color-text-default);\n\tborder: none;\n}\n\n.warning {\n\tbackground-color: var(--lok-color-background-warning);\n\tcolor: var(--lok-color-text-warning);\n\tfont: var(--lok-typography-body-tiny-default);\n}\n\n.titleContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: var(--lok-spacing-2);\n}\n\n.title {\n\tfont: var(--lok-typography-heading-4);\n\n\t&.placeholder {\n\t\tcolor: var(--lok-color-text-disabled);\n\t}\n}\n\n.statusTag {\n\tcolor: var(--lok-color-text-success);\n\tbackground-color: var(--lok-color-background-success);\n\tborder: none;\n\n\theight: 100%;\n\tpadding: var(--lok-spacing-1) var(--lok-spacing-2);\n}\n\n.integrationIconContainer {\n\tdisplay: flex;\n\talign-items: center;\n\tbackground-color: var(--lok-color-background-surface-fore);\n\tborder-radius: var(--lok-radius-tag);\n\tpadding: var(--lok-spacing-1) var(--lok-spacing-2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outerContainer": `XWgNIBV8SL9_YW_P`,
	"borderWrapper": `pWOgeIFL71QEubsE`,
	"container": `xs64TPEyy4qKV6_e`,
	"icon": `RG8i_eycAvlNcbYj`,
	"target": `FGngKWW_S50GAwjn`,
	"projects": `qxtYX4D9FMYZzbHo`,
	"projectsContainer": `wwqVk4q4zXw_JjRZ`,
	"projectsTag": `FMqupTC5ECgCCIf4`,
	"warning": `EtsIZU2n3W4N0hPe`,
	"titleContainer": `wdvRZq_FGeYPjehu`,
	"title": `lrYptlxhok0jDBbz`,
	"placeholder": `pj9IKS_hMaK0lnSP`,
	"statusTag": `q3mqaD2PiQFiNJuL`,
	"integrationIconContainer": `oFJwfT7yGLMao9cD`
};
export default ___CSS_LOADER_EXPORT___;
